import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { Calendar, Tag, CheckCircle2, ArrowRight } from "lucide-react";

const getNewsItems = (lang) => [
    {
        id: 1,
        category: lang === "tr" ? "Mühendislik & Proje" : "Engineering & Project",
        title: lang === "tr" 
            ? "Anahtar Teslim Endüstriyel Mutfak Projelendirme: 3D Tasarımdan Montaja Kusursuz Süreç"
            : "Turnkey Industrial Kitchen Projects: Seamless Process from 3D Design to Installation",
        date: lang === "tr" ? "07 Eylül 2026" : "September 07, 2026",
        content: (
            <div className="space-y-4 text-sm text-muted-foreground leading-relaxed">
                <p>
                    {lang === "tr"
                        ? "Profinoks olarak restoran, otel, hastane ve kurumsal tesislerde mimari ihtiyaçlara tam uyum sağlayan anahtar teslim projeler üretiyoruz. İşletmenizin menüsünden personel kapasitesine kadar her detayı analiz ederek maksimum operasyonel verimlilik hedefliyoruz."
                        : "As Profinoks, we execute turnkey projects tailored to architectural requirements in restaurants, hotels, hospitals, and institutional facilities. We analyze every detail from menu type to staff capacity to ensure maximum operational efficiency."}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
                    <div className="p-3 bg-muted/40 rounded-lg border border-border/60">
                        <span className="font-semibold text-foreground flex items-center gap-1.5 mb-1 text-xs uppercase tracking-wider">
                            <CheckCircle2 className="w-3.5 h-3.5 text-primary" />
                            {lang === "tr" ? "3D Modelleme & Alan Analizi" : "3D Modeling & Space Analysis"}
                        </span>
                        <p className="text-xs">
                            {lang === "tr" 
                                ? "Mutfak alanının her metrekaresi şef ve personelin ergonomik hareket rotalarına göre simüle edilir." 
                                : "Every square meter is simulated according to the ergonomic movement routes of chefs and staff."}
                        </p>
                    </div>
                    <div className="p-3 bg-muted/40 rounded-lg border border-border/60">
                        <span className="font-semibold text-foreground flex items-center gap-1.5 mb-1 text-xs uppercase tracking-wider">
                            <CheckCircle2 className="w-3.5 h-3.5 text-primary" />
                            {lang === "tr" ? "Altyapı & Tesisat Uyumu" : "Infrastructure Coordination"}
                        </span>
                        <p className="text-xs">
                            {lang === "tr" 
                                ? "Elektrik, su, gaz ve havalandırma hatları cihaz yerleşim planıyla milimetrik olarak örtüştürülür." 
                                : "Electrical, water, gas, and ventilation connections are aligned with millimeter precision."}
                        </p>
                    </div>
                </div>
            </div>
        )
    },
    {
        id: 2,
        category: lang === "tr" ? "Kalite & Malzeme" : "Quality & Material",
        title: lang === "tr" 
            ? "AISI 304 Kalite Paslanmaz Çelik Neden Profesyonel Mutfakların Vazgeçilmezidir?" 
            : "Why AISI 304 Stainless Steel is Essential for Professional Kitchens?",
        date: lang === "tr" ? "06 Eylül 2026" : "September 06, 2026",
        content: (
            <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
                <p>
                    {lang === "tr"
                        ? "Endüstriyel mutfaklarda hijyen ve mukavemetin temel şartı doğru hammadde seçimidir. Profinoks imalatında tercih edilen AISI 304 paslanmaz çelik, yüksek korozyon dayanımı ve gözeneksiz pürüzsüz yapısıyla öne çıkar."
                        : "The fundamental requirement of hygiene and durability in industrial kitchens is the right choice of raw materials. AISI 304 stainless steel preferred by Profinoks stands out with its high corrosion resistance and non-porous structure."}
                </p>
                <ul className="space-y-2 text-xs">
                    <li className="flex items-start space-x-2">
                        <span className="h-1.5 w-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0"></span>
                        <span><strong className="text-foreground">{lang === "tr" ? "Asit ve Neme Yüksek Direnç:" : "High Resistance to Acids & Moisture:"}</strong> {lang === "tr" ? "%18 krom ve %8 nikel alaşımıyla gıda asitlerine ve yoğun neme karşı paslanmazlık garantisi." : "18% chromium and 8% nickel alloy guarantees rust resistance against food acids and humidity."}</span>
                    </li>
                    <li className="flex items-start space-x-2">
                        <span className="h-1.5 w-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0"></span>
                        <span><strong className="text-foreground">{lang === "tr" ? "Maksimum Hijyen Standardı:" : "Maximum Hygiene Standard:"}</strong> {lang === "tr" ? "Bakteri barındırmayan pürüzsüz yüzeyler HACCP ve uluslararası gıda güvenliği yönergelerine tam uyumludur." : "Bacteria-free smooth surfaces comply 100% with HACCP and international food safety guidelines."}</span>
                    </li>
                    <li className="flex items-start space-x-2">
                        <span className="h-1.5 w-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0"></span>
                        <span><strong className="text-foreground">{lang === "tr" ? "Uzun Yatırım Ömrü:" : "Long Investment Lifespan:"}</strong> {lang === "tr" ? "Ağır mutfak temposunda eğilme, çatlama veya lekelenme yapmadan yıllarca ilk günkü parlaklığını korur." : "Preserves its initial structural strength and shine for decades without warping or tarnishing."}</span>
                    </li>
                </ul>
            </div>
        )
    },
    {
        id: 3,
        category: lang === "tr" ? "Enerji & Tasarruf" : "Energy & Savings",
        title: lang === "tr" 
            ? "Profesyonel Mutfaklarda Enerji Tasarrufu: Yeni Nesil Bulaşık Yıkama ve Pişirme Teknolojileri" 
            : "Energy Efficiency in Commercial Kitchens: Next-Gen Warewashing and Cooking Tech",
        date: lang === "tr" ? "05 Eylül 2026" : "September 05, 2026",
        content: (
            <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
                <p>
                    {lang === "tr"
                        ? "Yükselen enerji maliyetleri karşısında Profinoks akıllı mutfak sistemleri işletme giderlerini %40'a varan oranlarda azaltır. Isı geri dönüşümlü giyotin bulaşık makinelerimiz ve indüksiyonlu pişirme bloklarımız mutfak ekonomisinde devrim yaratmaktadır."
                        : "In the face of rising utility costs, Profinoks smart kitchen systems reduce operational expenses by up to 40%. Our heat recovery hood dishwashers and induction cooking blocks transform kitchen operational economy."}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-xs pt-1">
                    <div className="p-3 bg-muted/40 rounded-lg border border-border/60">
                        <span className="font-bold text-primary block mb-1">
                            {lang === "tr" ? "Isı Geri Dönüşümlü (HR) Yıkama" : "Heat Recovery (HR) Washing"}
                        </span>
                        {lang === "tr" 
                            ? "Tahliye edilen sıcak buharı absorbe ederek giriş suyunu ısıtır; hem elektrik tasarrufu sağlar hem de mutfak ortam nemini düşürür." 
                            : "Recovers exhaust steam to preheat incoming water, reducing electricity consumption and lowering ambient humidity."}
                    </div>
                    <div className="p-3 bg-muted/40 rounded-lg border border-border/60">
                        <span className="font-bold text-primary block mb-1">
                            {lang === "tr" ? "Optimum Su ve Deterjan Dozajı" : "Optimized Water & Chemical Dosing"}
                        </span>
                        {lang === "tr" 
                            ? "Yıkama döngüsü başına sadece 2.5 - 2.8 litre su harcayarak yıllık binlerce ton su tasarrufu elde edilir." 
                            : "Using just 2.5 - 2.8 liters of water per cycle saves thousands of tons of water annually."}
                    </div>
                </div>
            </div>
        )
    },
    {
        id: 4,
        category: lang === "tr" ? "Soğutma & Depolama" : "Refrigeration & Storage",
        title: lang === "tr" 
            ? "Modüler Soğuk Hava Depoları ve Şok Dondurucular (Blast Chillers): Gıda Güvenliğinde Sıfır Risk" 
            : "Modular Cold Storage Rooms & Blast Chillers: Zero Risk in Food Safety",
        date: lang === "tr" ? "04 Eylül 2026" : "September 04, 2026",
        content: (
            <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
                <p>
                    {lang === "tr"
                        ? "Taze gıdaların lezzet, besin değeri ve hijyenini korumak için endüstriyel soğutma kritik bir zincirdir. Profinoks modüler soğuk odalar ve şok dondurucular, bakteri oluşumuna fırsat vermeden gıdaları güvenle saklar."
                        : "Maintaining freshness, nutritional value, and hygiene relies heavily on industrial refrigeration chains. Profinoks modular cold rooms and blast chillers preserve food safely without allowing bacterial proliferation."}
                </p>
                <div className="space-y-2 text-xs">
                    <p><strong className="text-foreground">{lang === "tr" ? "Şok Soğutma (+90°C -> +3°C):" : "Blast Chilling (+90°C -> +3°C):"}</strong> {lang === "tr" ? "Pişmiş ürünleri 90 dakikada güvenli soğutma derecesine ulaştırarak bakteri üreme risk bölgesini atlar." : "Brings cooked food down to safe temperatures in 90 minutes, bypassing the bacterial danger zone."}</p>
                    <p><strong className="text-foreground">{lang === "tr" ? "42 kg/m³ Poliüretan İzolasyon:" : "42 kg/m³ Polyurethane Insulation:"}</strong> {lang === "tr" ? "Eksantrik kilitli sandviç paneller ile sıfır ısı köprüsü ve minimum kompresör çalışma süresi." : "Eccentric-lock sandwich panels ensure zero thermal bridging and minimal compressor wear."}</p>
                </div>
            </div>
        )
    },
    {
        id: 5,
        category: lang === "tr" ? "Hijyen & HACCP" : "Hygiene & HACCP",
        title: lang === "tr" 
            ? "HACCP Uyumlu Profesyonel Mutfak Yerleşimi: Çapraz Bulaşmayı Önleyen İş Akışı" 
            : "HACCP Compliant Kitchen Layout: Workflow Preventing Cross-Contamination",
        date: lang === "tr" ? "03 Eylül 2026" : "September 03, 2026",
        content: (
            <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
                <p>
                    {lang === "tr"
                        ? "Uluslararası gıda güvenliği denetimlerinde tam not almanın anahtarı doğru mimari yerleşimdir. 'İleri Akış' (Forward Flow) prensibimizle kirli ve temiz rotalar asla kesişmez."
                        : "The key to passing international food safety audits lies in correct architectural positioning. With our 'Forward Flow' principle, dirty and clean circulation lines never intersect."}
                </p>
                <ul className="space-y-2 text-xs">
                    <li className="flex items-start space-x-2">
                        <span className="h-1.5 w-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0"></span>
                        <span><strong className="text-foreground">{lang === "tr" ? "Tek Yönlü Lojistik Akış:" : "One-Way Logistics Flow:"}</strong> {lang === "tr" ? "Mal kabul, depolama, hazırlık, pişirme, servis ve bulaşıkhane istasyonları sıralı düzenlenir." : "Receiving, storage, prep, cooking, plating, and warewashing are arranged sequentially."}</span>
                    </li>
                    <li className="flex items-start space-x-2">
                        <span className="h-1.5 w-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0"></span>
                        <span><strong className="text-foreground">{lang === "tr" ? "Renk Kodlu Kesim İstasyonları:" : "Color-Coded Cutting Stations:"}</strong> {lang === "tr" ? "Kırmızı et, beyaz et, balık, sebze ve unlu mamul hazırlık tezgahları bağımsız alanlarda kurgulanır." : "Red meat, poultry, fish, produce, and bakery prep benches are separated into dedicated zones."}</span>
                    </li>
                </ul>
            </div>
        )
    },
    {
        id: 6,
        category: lang === "tr" ? "Fırın & Unlu Mamuller" : "Bakery & Dough",
        title: lang === "tr" 
            ? "Pastane, Fırın ve Unlu Mamul Hatlarında Fimak & Profinoks Teknolojik Gücü" 
            : "Technological Power of Fimak & Profinoks in Bakery and Patisserie Production",
        date: lang === "tr" ? "02 Eylül 2026" : "September 02, 2026",
        content: (
            <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
                <p>
                    {lang === "tr"
                        ? "1976'dan günümüze unlu mamul sektörünün lider üreticisi FİMAK kalitesi, Profinoks güvencesiyle işletmelerinizde. Hamur yoğurmadan mayalamaya ve pişirmeye kadar entegre hatlar sunuyoruz."
                        : "The legendary manufacturing heritage of FIMAK, established in 1976, is brought to your facilities with the assurance of Profinoks. We deliver integrated lines from kneading to proofing and baking."}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs pt-1">
                    <div className="p-2.5 bg-muted/40 rounded border border-border/60">
                        <span className="font-semibold text-foreground block">{lang === "tr" ? "Spiral Mikser & Kestart Hatları" : "Spiral Mixers & Dividers"}</span>
                        <span>{lang === "tr" ? "Hamurun yapısını ısıtmadan yoğuran ve hassas gramajlama yapan sistemler." : "Systems that knead without heating gluten structures and ensure accurate scaling."}</span>
                    </div>
                    <div className="p-2.5 bg-muted/40 rounded border border-border/60">
                        <span className="font-semibold text-foreground block">{lang === "tr" ? "Döner Arabalı & Katlı Fırınlar" : "Rotary Rack & Deck Ovens"}</span>
                        <span>{lang === "tr" ? "Homojen buhar dağılımı ile her tepside eşit kabarma ve altın rengi kabuk." : "Uniform steam distribution delivering consistent rise and golden crust across all trays."}</span>
                    </div>
                </div>
            </div>
        )
    },
    {
        id: 7,
        category: lang === "tr" ? "Açık Büfe & Teşhir" : "Buffet & Display",
        title: lang === "tr" 
            ? "Otel ve Restoranlar İçin Modern Açık Büfe ve Self-Servis Sunum Hatları" 
            : "Modern Open Buffet and Self-Service Presentation Lines for Hotels & Restaurants",
        date: lang === "tr" ? "01 Eylül 2026" : "September 01, 2026",
        content: (
            <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
                <p>
                    {lang === "tr"
                        ? "Misafirlerinize unutulmaz bir gastronomi deneyimi sunmanın yolu estetik ve hijyenik büfelerden geçer. Profinoks sıcak, soğuk ve nötr açık büfe üniteleri modern mimari trendlerle üretilmektedir."
                        : "Delivering an unforgettable dining experience requires aesthetic, hygienic presentation units. Profinoks hot, cold, and neutral buffet lines are crafted in sync with modern architectural trends."}
                </p>
                <ul className="space-y-1.5 text-xs">
                    <li><strong className="text-foreground">{lang === "tr" ? "Gömme Soğutmalı Salatbarlar:" : "Drop-in Refrigerated Salad Bars:"}</strong> {lang === "tr" ? "Mezelerin ve taze yeşilliklerin gün boyu ilk anki diriliğinde kalmasını sağlayan statik/üflemeli soğutma." : "Static or ventilated cooling keeping cold appetizers and fresh greens crisp throughout service."}</li>
                    <li><strong className="text-foreground">{lang === "tr" ? "Sıcak Bain-Marie Tezgahları:" : "Heated Bain-Marie Counters:"}</strong> {lang === "tr" ? "Kuru veya sulu ısıtma sistemleri ile yemeklerin kurumasını önleyen hassas termostat kontrolü." : "Accurate thermostat control preventing drying with wet or dry heating systems."}</li>
                </ul>
            </div>
        )
    },
    {
        id: 8,
        category: lang === "tr" ? "Havalandırma & Güvenlik" : "Ventilation & Safety",
        title: lang === "tr" 
            ? "Endüstriyel Havalandırma ve Davlumbaz Sistemleri: Yangın Güvenliği ve Temiz Hava" 
            : "Commercial Kitchen Ventilation & Hood Systems: Fire Safety & Air Quality",
        date: lang === "tr" ? "30 Ağustos 2026" : "August 30, 2026",
        content: (
            <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
                <p>
                    {lang === "tr"
                        ? "Yoğun pişirme dumanı, koku ve yağ partikülleri doğru tahliye edilmediğinde yangın tehlikesi oluşturur. Profinoks alev savar labirent filtreli davlumbazları güvenliği ve temiz hava sirkülasyonunu garanti eder."
                        : "Heavy smoke, odor, and airborne grease pose severe fire hazards if not evacuated correctly. Profinoks baffle-filter exhaust hoods ensure maximum safety and fresh air circulation."}
                </p>
                <div className="space-y-2 text-xs">
                    <p><strong className="text-foreground">{lang === "tr" ? "Alev Savar Labirent Filtreler:" : "Flame-Resistant Baffle Filters:"}</strong> {lang === "tr" ? "Kıvılcımların baca kanalına girmesini önler ve yağ partiküllerini özel tahliye kanalında toplar." : "Prevents sparks from entering ducts and channels grease droplets into catch cups."}</p>
                    <p><strong className="text-foreground">{lang === "tr" ? "Otomatik Yangın Söndürme Entegrasyonu:" : "Automatic Fire Suppression Systems:"}</strong> {lang === "tr" ? "Ocak ve fritöz gruplarında olası alevlenmelere anında müdahale eden nozul altyapısı." : "Direct nozzle infrastructure for instant chemical discharge over ranges and fryers."}</p>
                </div>
            </div>
        )
    },
    {
        id: 9,
        category: lang === "tr" ? "Cafe & Bar Konsepti" : "Cafe & Bar Concept",
        title: lang === "tr" 
            ? "Kahve Dükkanı ve Cafe-Bar Projelerinde Hızlı Servis İçin Kompakt İstasyon Mimarisi" 
            : "Compact Station Architecture for Fast Service in Coffee Shops & Cafe-Bars",
        date: lang === "tr" ? "28 Ağustos 2026" : "August 28, 2026",
        content: (
            <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
                <p>
                    {lang === "tr"
                        ? "Metrekaresi kısıtlı cafe ve barlarda hız her şeydir. Profinoks bar istasyonları barista ve barmenlerin adım atmadan tüm ekipmanlara ulaşabilmesi amacıyla özel olarak tasarlanır."
                        : "In tight cafe and bar spaces, speed is everything. Profinoks custom cocktail and coffee stations allow baristas and bartenders to reach every tool without taking unnecessary steps."}
                </p>
                <ul className="space-y-1.5 text-xs">
                    <li><strong className="text-foreground">{lang === "tr" ? "Entegre Bar İstasyonları:" : "Integrated Bar Stations:"}</strong> {lang === "tr" ? "Buz küveti, yıkama evyesi, blender alanı, şurup rafları ve atık gözlerinin tek gövdede birleşimi." : "Built-in ice well, speed rails, blender station, rinse sink, and trash chute in one module."}</li>
                    <li><strong className="text-foreground">{lang === "tr" ? "Bar Altı Hızlı Bulaşık Makineleri:" : "Undercounter Glasswashers:"}</strong> {lang === "tr" ? "120 saniyelik çevrimle bardakları lekesiz ve servise hazır çıkaran kompakt tasarım." : "Compact design delivering spotless, sanitized glasses ready for immediate reuse in 120 seconds."}</li>
                </ul>
            </div>
        )
    },
    {
        id: 10,
        category: lang === "tr" ? "Toplu Yemek & Catering" : "Catering & Institutional",
        title: lang === "tr" 
            ? "Hastaneler, Okullar ve Askeri Birlikler İçin Yüksek Kapasiteli Catering Mutfak Çözümleri" 
            : "High-Capacity Catering Kitchen Solutions for Hospitals, Schools & Campuses",
        date: lang === "tr" ? "25 Ağustos 2026" : "August 25, 2026",
        content: (
            <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
                <p>
                    {lang === "tr"
                        ? "Günde binlerce kişiye kesintisiz sıcak yemek servisi yapılan dev tesislerde Profinoks ağır hizmet tipi pişirme ve taşıma ekipmanları güvenilirliğini kanıtlamıştır."
                        : "In high-capacity institutions serving thousands of hot meals daily, Profinoks heavy-duty cooking and transit equipment prove their unmatched reliability."}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs pt-1">
                    <div className="p-2.5 bg-muted/40 rounded border border-border/60">
                        <span className="font-semibold text-foreground block">{lang === "tr" ? "Devrilir Tavalar & Kaynatma Kazanları" : "Tilting Braising Pans & Boiling Kettles"}</span>
                        <span>{lang === "tr" ? "150 - 500 litrelik buhar ve elektrik ceketli yüksek kapasiteli kazanlar." : "150 - 500 liter steam-jacketed and electric kettles for bulk cooking."}</span>
                    </div>
                    <div className="p-2.5 bg-muted/40 rounded border border-border/60">
                        <span className="font-semibold text-foreground block">{lang === "tr" ? "Termobox Taşıma & Konveyörlü Yıkama" : "Insulated Thermoboxes & Conveyor Washers"}</span>
                        <span>{lang === "tr" ? "Isı kaybı olmadan dağıtım ve saatte 3000 tabak kapasiteli tünel bulaşık hatları." : "Zero-heat-loss transport and tunnel dishwashing lines handling 3000+ plates/hour."}</span>
                    </div>
                </div>
            </div>
        )
    },
    {
        id: 11,
        category: lang === "tr" ? "Rehber & Hizmet" : "Guide & Service",
        title: lang === "tr" ? "Endüstriyel Mutfak Projesi Hizmeti Verdiğimiz Alanlar" : "Fields of Industrial Kitchen Project Services",
        date: lang === "tr" ? "17 Şubat 2026" : "February 17, 2026",
        content: (
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs text-muted-foreground">
                {[
                    lang === "tr" ? "Restoran mutfağı" : "Restaurant kitchen",
                    lang === "tr" ? "Otel Mutfağı ve Otel Mutfak Ekipmanları" : "Hotel Kitchen and Equipment",
                    lang === "tr" ? "Steakhouse mutfağı ve et teşhir dolapları" : "Steakhouse kitchen and meat display cabinets",
                    lang === "tr" ? "Askeri tesis mutfağı" : "Military facility kitchen",
                    lang === "tr" ? "Bar Projeleri" : "Bar Projects",
                    lang === "tr" ? "Hastane mutfakları" : "Hospital kitchens",
                    lang === "tr" ? "Fastfood ekipmanları ve mutfağı" : "Fast food equipment and kitchen",
                    lang === "tr" ? "Okul mutfak projeleri" : "School kitchen projects",
                    lang === "tr" ? "Yurt mutfakları" : "Dormitory kitchens",
                    lang === "tr" ? "Burger mutfağı" : "Burger kitchen",
                    lang === "tr" ? "Pastane mutfağı ve pasta dolapları" : "Patisserie kitchen and cake cabinets",
                    lang === "tr" ? "Cafe mutfağı ve cafe bar ekipmanları" : "Cafe kitchen and cafe bar equipment",
                    lang === "tr" ? "Dinlenme tesisi mutfağı" : "Rest area kitchen",
                    lang === "tr" ? "Catering mutfağı" : "Catering kitchen",
                    lang === "tr" ? "Horeca mutfağı" : "Horeca kitchen",
                    lang === "tr" ? "Fırın Ekipmanları" : "Bakery Equipment",
                    lang === "tr" ? "Dönerci Mutfakları" : "Doner Shop Kitchens",
                    lang === "tr" ? "Her türlü paslanmaz mutfaklar" : "All kinds of stainless kitchens",
                    lang === "tr" ? "Endüstriyel Mutfak Danışmanlığı" : "Industrial Kitchen Consultancy"
                ].map((item, i) => (
                    <li key={i} className="flex items-center space-x-2">
                        <span className="h-1.5 w-1.5 rounded-full bg-primary flex-shrink-0"></span>
                        <span>{item}</span>
                    </li>
                ))}
            </ul>
        )
    },
    {
        id: 12,
        category: lang === "tr" ? "Makine & Ekipman" : "Machinery & Equipment",
        title: lang === "tr" ? "Endüstriyel Bulaşık Makinası Alma ve Seçim Rehberi" : "Industrial Dishwasher Buying and Selection Guide",
        date: lang === "tr" ? "10 Şubat 2026" : "February 10, 2026",
        content: (
            <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
                <p>{lang === "tr" ? "Bulaşık makineleri profesyonel bir mutfağın kalbidir ve operasyonun kesintisiz akmasını sağlar." : "Dishwashers are the heart of a professional kitchen, keeping operations running without disruption."}</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs">
                    <p><strong className="text-foreground">{lang === "tr" ? "Tezgah Altı Tip:" : "Undercounter Type:"}</strong> {lang === "tr" ? "Kafeler ve butik restoranlar için saatte 500 tabak kapasite." : "500 plates/hour capacity for cafes and boutique restaurants."}</p>
                    <p><strong className="text-foreground">{lang === "tr" ? "Giyotin Tip:" : "Hood Type:"}</strong> {lang === "tr" ? "Yoğun restoran ve oteller için saatte 1000 tabak standart kapasite." : "Standard 1000 plates/hour capacity for busy restaurants and hotels."}</p>
                </div>
            </div>
        )
    }
];

const NewsPage = () => {
    const { lang } = useLanguage();
    const newsItems = getNewsItems(lang);

    return (
        <div className="pt-[115px] sm:pt-[125px] bg-background pb-20 text-foreground min-h-screen">
            <div className="w-full max-w-[1900px] mx-auto px-4 sm:px-6 lg:px-8 pt-4 sm:pt-6 pb-12">
                <header className="mb-8 border-b border-black/10 pb-6">
                    <h1 className="text-3xl md:text-4xl font-bold tracking-tight uppercase text-primary">
                        {lang === "tr" ? "HABERLER & BLOG" : "NEWS & BLOG"}
                    </h1>
                    <p className="mt-2 text-muted-foreground text-sm max-w-3xl">
                        {lang === "tr" 
                            ? "Profinoks dünyasından en son güncellemeler, sektörel rehberler ve endüstriyel mutfak teknolojileri."
                            : "Latest updates, sectoral guides, and industrial kitchen technologies from the world of Profinoks."}
                    </p>
                </header>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
                    {newsItems.map((item) => (
                        <article
                            key={item.id}
                            className="group overflow-hidden rounded-2xl border border-black/10 bg-white transition-all duration-300 hover:border-primary/40 hover:shadow-md shadow-sm flex flex-col justify-between"
                        >
                            <div className="p-6 md:p-8">
                                <div className="flex flex-wrap items-center gap-2.5 mb-4">
                                    <span className="text-[11px] font-bold uppercase tracking-wider text-primary bg-primary/10 px-2.5 py-1 rounded-md">
                                        {lang === "tr" ? "HABER" : "NEWS"} #{item.id}
                                    </span>
                                    {item.category && (
                                        <span className="text-[11px] font-semibold text-muted-foreground bg-muted px-2.5 py-1 rounded-md flex items-center gap-1">
                                            <Tag className="w-3 h-3 text-primary/70" />
                                            {item.category}
                                        </span>
                                    )}
                                    <span className="text-[11px] text-muted-foreground uppercase tracking-wider ml-auto flex items-center gap-1">
                                        <Calendar className="w-3 h-3 text-muted-foreground/70" />
                                        {item.date}
                                    </span>
                                </div>
                                <h2 className="text-lg md:text-xl font-bold text-foreground mb-4 group-hover:text-primary transition-colors leading-snug">
                                    {item.title}
                                </h2>
                                <div className="border-t border-black/5 pt-4">
                                    {item.content}
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default NewsPage;
